import { getGsap } from "./GsapGlobals";

export class ScrollRevealController {
    static initFadeUp(): void {
        const gsap = getGsap();
        if (!gsap) return;
        document.querySelectorAll<HTMLElement>(".fade-up").forEach((item) => {
            if (item.closest(".no-faq") || item.closest(".no-service")) return;
            gsap.fromTo(
                item,
                { opacity: 0, y: 40 },
                {
                    opacity: 1,
                    y: 0,
                    duration: 0.9,
                    clearProps: "y",
                    scrollTrigger: {
                        trigger: item,
                        start: "top 80%",
                        end: "bottom 20%",
                    },
                },
            );
        });
    }

    static initBlur(): void {
        const gsap = getGsap();
        if (!gsap) return;
        document.querySelectorAll<HTMLElement>(".blur-js").forEach((item) => {
            gsap.fromTo(
                item,
                { opacity: 0, filter: "blur(16px)", y: 40 },
                {
                    opacity: 1,
                    filter: "blur(0px)",
                    duration: 1.2,
                    ease: "power2.out",
                    y: 0,
                    clearProps: "y",
                    scrollTrigger: {
                        trigger: item,
                        start: "top 80%",
                        end: "bottom 20%",
                    },
                },
            );
        });
    }

    static initListUp(): void {
        const gsap = getGsap();
        if (!gsap) return;
        document.querySelectorAll<HTMLElement>(".list-js").forEach((list) => {
            const items = list.querySelectorAll<HTMLElement>(":scope > li");
            if (items.length === 0) return;
            gsap.fromTo(
                items,
                { opacity: 0, y: 50 },
                {
                    opacity: 1,
                    y: 0,
                    duration: 0.9,
                    stagger: 0.3,
                    clearProps: "y",
                    scrollTrigger: {
                        trigger: list,
                        start: "top 80%",
                        end: "bottom 20%",
                    },
                },
            );
        });
    }
}
